export const POWERBI_REPORT = 5;
export const METABASE_REPORT = 3;
export const FORCE_BI_REPORT = 4;

export const EXTERNAL_REPORTS = [METABASE_REPORT, FORCE_BI_REPORT, POWERBI_REPORT];

export const DASHBOARD_TYPE = {
    DEFAULT: 'default',
    FORCE_BI: 'ForceBI',
    METABASE: 'Metabase',
    POWER_BI: 'PowerBI',
    SFM: 'SFM',
};

export const PROVIDERS_OPTIONS = [
    {
        label: 'PowerBI',
        value: POWERBI_REPORT,
    },
];
export const PROVIDERS_CONFIG = {
    [POWERBI_REPORT]: {
        urlRegex: /^https:\/\/app\.powerbi\.com\//,
    },
};
